import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'titleContainer',
    (theme, [type]) => [
	  `	
			:lang(ar) {
				transform: scaleX(-1);
				direction: rtl;
			}
			position: relative;
			width: 96%;
			margin-left: 0;
			float: left;

			@media (max-width: 720px) {
				width: calc(100% - 34px);
			}
		`,
      (type === 'QUOTE' || type === 'STATEMENT') &&
        `
			float: none;
			width: 100%;

			@media (max-width: 720px) {
				width: 100%;
			}
		`,
      type === 'QUOTE' &&
        `
			display: flex;
			flex-direction: column;
			align-items: center;
		`
    ]
  ]
]);
